export const PATHS = {
    base: 'admin/attachment'
}

export const Topics = {
    upload: `${PATHS.base}/upload`,
    download: `${PATHS.base}/download`
}

export type Request = {
    username: string
    domain: string
}

export type Response = {
    url: string
}

/** Download de um anexo do bucket de upload: só objetos com chave dentro de `domain/`. */
export type DownloadRequest = {
    domain: string
    url: string
}
